module.exports = __webpack_public_path__ + "img/icon.c9418a1b.png";